import { Info } from 'lucide-react'

import { Toggle } from '~/components/component-library/Toggle'
import { CompactToggleableProps } from '~/components/component-library/Toggleable/types'
import { Tooltip } from '~/components/component-library/Tooltip'
import { cn } from '~/utils/tailwind-utils'

export const CompactToggleable = ({
  label,
  tooltip,
  isChecked,
  onCheckedChange,
  isDisabled = false,
  disabledReason,
}: CompactToggleableProps) => {
  const field = (
    <button
      type="button"
      role="switch"
      aria-checked={isChecked}
      aria-disabled={isDisabled || undefined}
      tabIndex={isDisabled ? -1 : undefined}
      className={cn('flex items-center gap-2 text-xs text-secondary', {
        'cursor-pointer': !isDisabled,
        'cursor-not-allowed': isDisabled,
        'justify-end': !!label,
      })}
      onClick={() => {
        if (!isDisabled) onCheckedChange(!isChecked)
      }}
    >
      {label && (
        <span className="flex items-center gap-1">
          <span>{label}</span>
          {tooltip && (
            <Tooltip content={tooltip}>
              <Info className="size-3" />
            </Tooltip>
          )}
        </span>
      )}
      <Toggle isChecked={isChecked} size="small" isDisabled={isDisabled} />
    </button>
  )

  // The disabled-reason tooltip belongs on the interactive field, not the
  // decorative Toggle, so it shows on hover anywhere across the cluster.
  if (!isDisabled || !disabledReason) {
    return field
  }

  return <Tooltip content={disabledReason}>{field}</Tooltip>
}
